'use client';
import React, { useState, useEffect } from 'react';
import { PlayIcon, XMarkIcon } from "@heroicons/react/24/solid";

const VideoModalButton = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <button
        onClick={() => setIsVideoOpen(!isVideoOpen)}
        className={`fixed z-[999] right-0 bottom-24 ${
          !isVideoOpen ? 'bg-blue-600' : 'bg-red-600'
        } text-white py-2 sm:py-4 px-3 sm:px-6 rounded shadow-lg transition w-auto opacity-80 hover:opacity-100 flex items-center gap-2`}
        aria-label={!isVideoOpen ? "Play Home Appraisal Video" : "Close Video"}
        aria-expanded={isVideoOpen}
      >
        {!isVideoOpen 
          ? (
            <>
              <PlayIcon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden="true" />
              <span className="hidden sm:inline">
                {!isScrolled && "Why Get An Appraisal?"}
              </span>
            </>
          ) : (
            <>
              <XMarkIcon className="h-5 w-5 sm:h-6 sm:w-6" aria-hidden="true" />
              <span className="hidden sm:inline">
                {!isScrolled && "Close Video"}
              </span>
            </>
          )
        }
      </button>
      <div 
        className={`fixed z-[999] right-0 bottom-40 transition-transform duration-300 ${
          isVideoOpen ? 'transform translate-y-0' : 'transform translate-y-full hidden'
        }`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="video-title"
      >
        <div className="bg-white dark:bg-gray-800 w-[90vw] sm:w-[25vw] rounded-lg shadow-lg p-4">
          <div className="aspect-video">
            <iframe
              width="100%"
              height="100%"
              src={isVideoOpen ? "https://player.vimeo.com/video/271555335" : ""}
              title="Home Appraisal Process Video"
              id="video-title"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoModalButton;
